import { productTransfer, TransferBeteweenWarehouse } from "interfaces";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface TransferWarehouseStoreProps {
  // * Properties
  payloadTransfer: TransferBeteweenWarehouse;
  productsTransfer: productTransfer[];

  // * Methods
  setPayloadTransfer: (payload: TransferBeteweenWarehouse) => void;
  addProductTransfer: (payload: productTransfer) => void;
  removeProductTransfer: (payload: number) => void;

  clearAllStore: () => void;
}

export const useTransferWarehouseStore = create<TransferWarehouseStoreProps>()(
  devtools((set) => ({
    // * Properties
    payloadTransfer: {
      warehousefrom_id: 0,
      warehouseto_id: 0,
      observation: "",
      transferDate: "",
    },
    productsTransfer: [],

    // * Methods
    setPayloadTransfer: (payload) =>
      set((state) => ({ payloadTransfer: payload })),
    addProductTransfer: (payload) =>
      set((state) => ({
        productsTransfer: [...state.productsTransfer, payload],
      })),

    removeProductTransfer: (payload) => {
      set((state) => ({
        productsTransfer: state.productsTransfer.filter(
          (product) => product.product_id !== payload
        ),
      }));
    },

    clearAllStore: () =>
      set(() => ({
        payloadTransfer: {
          warehousefrom_id: 0,
          warehouseto_id: 0,
          observation: "",
          transferDate: new Date().toISOString().split("T")[0],
        },
        productsTransfer: [],
      })),
  }))
);
